<template>
  <div class="search-destinations-base">
    <div class="search-condition">
      <BaseSearchConditionModal
          :keyword="keyword"
          :is-and-search="isAndSearch"
          :conditions="conditions"
          :store-path="storePath"
          :res-path="responsePath"
          :save-key="saveKey"
          :base-query="null"
          :is-validation-only-condition="true"
          @search="search" />
    </div>
    <BaseTableList
        class="table"
        height="500"
        row-class-name="clickable"
        :table-set-list="destinationSetList"
        :display-items="showData"
        @row-dblclick="onRowDoubleClick">
      <template slot="title">
        <div class="table-header">
          <h3 class="table_title">検索結果</h3>
          <h4 v-show="showDataCount"
              class="table_count">
            {{ dataCount }} 件
          </h4>
        </div>
      </template>
      <template slot="slots"
          slot-scope="{ row }">
        <slot :name="'slots'"
            :row="row" />
      </template>
    </BaseTableList>
    <!-- ページネーション -->
    <div class="base-pagination">
      <el-pagination
          :current-page="currentPage"
          :page-size="100"
          :total="destinationData.length"
          background
          layout="prev, pager, next"
          @current-change="onPaginationCurrentChange" />
    </div>
  </div>
</template>

<style scoped>
.search-condition {
  margin: 5px 15px;
}
.search-condition .input-label {
  font-size: 14px;
  font-weight: bold;
  color: #9da6ba;
  text-align: right;
  padding-right: 10px;
}
.search-condition .search_button {
  text-align: right;
}
.el-row {
  margin: 5px 0;
}
.table_title {
  float: left;
}
.table_count {
  float: right;
}

.keywordInput {
  width: 250px;
}

.search-condition ::v-deep .base-search-condition > div {
  width: 400px;
}

.base-pagination {
  margin-bottom: 10px;
}

</style>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

import common from '@/utils/common'
import message from '@/utils/message'

import * as stockQuery from '@/queries/stock'

import BaseTableList from '@/components/molecules/BaseTableList'
import BaseSearchConditionModal from '@/components/organisms/BaseSearchConditionModal'

export default {
  name: 'SearchDestinations',
  components: {
    BaseTableList,
    BaseSearchConditionModal
  },
  inject: ['parentValidator'],
  props: {
    tableSetList: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      responsepath: '',
      currentPage: 1,
      destinationData: []
    }
  },
  computed: {
    ...mapGetters({
      searchConditions: 'searchConditions'
    }),
    destinationSetList () {
      return [
        {
          type: 'String', label: '出荷先コード', path: 'code', width: 200
        },
        {
          type: 'String', label: '出荷先名称', path: 'name'
        },
        {
          type: 'String', label: '郵便番号', path: 'postalCode'
        },
        {
          type: 'String', label: '都道府県', path: 'stateCode'
        },
        {
          type: 'String', label: '市区町村', path: 'city'
        },
        {
          type: 'String', label: '住所1', path: 'address1'
        },
        {
          type: 'String', label: '住所2', path: 'address2'
        },
        {
          type: 'String', label: '電話番号', path: 'phone'
        }
      ]
    },
    dataCount () {
      return this.destinationData.length
    },
    showDataCount () {
      return this.destinationData.length > 0
    },
    showData () {
      const min = (this.currentPage - 1) * 100
      const max = (this.currentPage) * 100
      return this.destinationData.filter((data, index) => index >= min && index < max)
    },
    storePath () {
      return 'Destination'
    },
    store () {
      return this.$store.state[this.storePath] || {}
    },
    keyword () {
      return this.store.searchKeyword || ''
    },
    isAndSearch () {
      return this.store.isAndSearch || false
    },
    conditions () {
      return this.store.searchConditions || {}
    },
    saveKey () {
      return 'destinationSearcherCondition'
    },
    responsePath () {
      return 'data.data.destinations.edges'
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
    async search () {
      try {
        this.$loadingService.show()
        let queryCondition = this.searchConditions(this.storePath)
        let query = stockQuery.GRAPH_QL_QUERY_DESTINATION_LIST
        query = common.addGraphQlCondition(query, queryCondition)
        const res = await common.postGraphQl(query)

        // 出荷先検索
        const totalCount = _.get(res, 'data.data.destinations.totalCount', 0)
        const listSize = _.chain(res).get('data.data.destinations.edges').size().value()

        if (totalCount !== listSize) {
          // 検索結果の件数が上限を超えた場合
          this.$notify.warning(message.MSG_306())
        }

        this.destinationData = _.chain(res)
          .get('data.data.destinations.edges')
          .map(val => _.get(val, 'node'))
          .value()

        // 結果が null の場合
        if (this.destinationData == null) {
          this.$notify.error({
            message: 'データを取得できませんでした。'
          })
          return
        }
        this.currentPage = 1
      } catch (error) {
        const message = _.get(error, 'ccsErrors.0.message')
        if (message) {
          this.$notify.error({ message })
          return
        }
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    onRowDoubleClick (row, column, event) {
      this.$emit('destination-selected', row)
    },
    onPaginationCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>
